module.exports = __webpack_public_path__ + "img/sinBarreras223.c0b67695.jpg";